export default __webpack_public_path__ + "static/media/successbank.bb02b74d.svg";